import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { isNative } from "@/lib/appConfig";

// Shows a thin banner when the device is offline so users know data may be stale.
// Uses @capacitor/network on native, the online/offline events on web.
// Adds "qc-offline" to <html> so the sticky header can offset itself via CSS.
export default function OfflineBanner() {
    const [offline, setOffline] = useState(false);

    useEffect(() => {
        let remove = () => {};
        if (isNative()) {
            (async () => {
                const { Network } = await import("@capacitor/network");
                const status = await Network.getStatus();
                setOffline(!status.connected);
                const h = await Network.addListener("networkStatusChange", (s) => setOffline(!s.connected));
                remove = () => h.remove();
            })();
        } else {
            const update = () => setOffline(!navigator.onLine);
            update();
            window.addEventListener("online", update);
            window.addEventListener("offline", update);
            remove = () => {
                window.removeEventListener("online", update);
                window.removeEventListener("offline", update);
            };
        }
        return () => remove();
    }, []);

    useEffect(() => {
        document.documentElement.classList.toggle("qc-offline", offline);
    }, [offline]);

    if (!offline) return null;
    return (
        <div
            className="offline-banner fixed top-0 left-0 right-0 z-[90] bg-wine text-bone text-center text-xs py-1.5 flex items-center justify-center gap-2"
            data-testid="offline-banner"
        >
            <WifiOff className="w-3.5 h-3.5" strokeWidth={2} />
            Sin conexion — los datos pueden estar desactualizados
        </div>
    );
}
